import { Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import useDimensions from 'Util/useDimensions';
import icX1 from 'Assets/img/field/ic_x_666.png';
import icX2 from 'Assets/img/field/ic_x_666@2x.png';
import icX3 from 'Assets/img/field/ic_x_666@3x.png';
import icXCircle1 from 'Assets/img/field/ic_x_circle_b2_20.png';
import icXCircle2 from 'Assets/img/field/ic_x_circle_b2_20@2x.png';
import icXCircle3 from 'Assets/img/field/ic_x_circle_b2_20@3x.png';
import icSync1 from 'Assets/img/field/ic_sync_fff_18.png';
import icSync2 from 'Assets/img/field/ic_sync_fff_18@2x.png';
import icSync3 from 'Assets/img/field/ic_sync_fff_18@3x.png';
import icArrowRight1 from 'Assets/img/field/ic_arrow_666.png';
import icArrowRight2 from 'Assets/img/field/ic_arrow_666@2x.png';
import icArrowRight3 from 'Assets/img/field/ic_arrow_666@3x.png';
import icArrowDown1 from 'Assets/img/field/ic_arrow_updown.png';
import icArrowDown2 from 'Assets/img/field/ic_arrow_updown@2x.png';
import icArrowDown3 from 'Assets/img/field/ic_arrow_updown@3x.png';
import icCheck1 from 'Assets/img/field/ic_check_fff_16.png';
import icCheck2 from 'Assets/img/field/ic_check_fff_16@2x.png';
import icCheck3 from 'Assets/img/field/ic_check_fff_16@3x.png';
import { getImageSet } from 'Util/DataUtils';
import IntlMessages from 'Util/IntlMessages';
import { useIntl } from 'react-intl';
import IntlTableCell from 'Components/Views/IntlTableCell';
import Api from 'Api';
import { dateFormat } from 'Util/DateUtils';
import { useDispatch, useSelector } from 'react-redux';
import { removeEmpty } from 'Util/DataUtils';
import { useError } from 'Api/hooks/useError';
import { setLoading } from 'Actions/LoadingActions';
import { updateFieldStaff } from 'Api/endpoints/User';
import DOMPurify from 'dompurify';
import Pagination from 'Components/common/Pagination';

const icX = getImageSet([icX1, icX2, icX3]);
const icXCircle = getImageSet([icXCircle1, icXCircle2, icXCircle3]);
const icSync = getImageSet([icSync1, icSync2, icSync3]);
const icArrowRight = getImageSet([icArrowRight1, icArrowRight2, icArrowRight3]);
const icArrowDown = getImageSet([icArrowDown1, icArrowDown2, icArrowDown3]);
const icCheck = getImageSet([icCheck1, icCheck2, icCheck3]);

// todo: 직책, 부서 추가
// todo: 베트남어 적용 후 헤더 길이 고정

const UpdatePopup = ({ isOpen, onClose, staffs, fieldId, refresh }) => {
  const dispatch = useDispatch();
  const { windowWidth } = useDimensions();
  const { formatMessage } = useIntl();
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(0);
  const [count, setCount] = useState(0);
  const [selectedStaffs, setSelectedStaffs] = useState([]);
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [sort, setSort] = useState('-id');
  const [items, setItems] = useState([]);
  const [nowFilter, setNowFilter] = useState(null);
  const { locale } = useSelector(state => state.settings.locale);
  const { showErrorPopup } = useError();
  const { user } = useSelector(state => state.authUser);

  const getList = useCallback(async () => {
    const data = removeEmpty({
      ...(nowFilter && { ...nowFilter }),
      page,
      sort,
    });

    try {
      const result = await Api.user.getStaffList(data);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message, onClose });
        return;
      }
      setItems(result.data.items);
      setLastPage(result.data.lastPage);
      setCount(result.data.count);
    } catch (e) {
      console.log(e);
    }
  }, [page, nowFilter, sort, showErrorPopup, onClose]);

  useEffect(() => {
    if (!isOpen) return;
    getList();
  }, [isOpen, getList]);

  useEffect(() => {
    if (!isOpen) return;
    setPage(1);
    setLastPage(0);
    setCount(0);
    setSelectedStaffs(staffs);
    setName('');
    setPhone('');
    setSort('-dateCreated');
    setItems([]);
    setNowFilter(null);
  }, [isOpen, staffs]);

  const toggleCheck = useCallback(item => {
    setSelectedStaffs(prev => {
      if (prev.some(x => x._id === item._id)) {
        return prev.filter(x => x._id !== item._id);
      }
      return [...prev, item];
    });
  }, []);

  // 정규표현식 특수문자를 이스케이프하는 함수
  const escapeRegExp = string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const changeWeightSelectedWord = (text, word) => {
    if (!word) return text;
    const escapedWord = escapeRegExp(word);
    const regex = new RegExp(`(${escapedWord})`, 'gi');
    return text.replace(regex, `<span style="font-weight: 700;">$1</span>`);
  };

  const onUpdateStaff = async () => {
    const data = {
      fieldId,
      staffs: selectedStaffs.map(x => x._id),
    };
    try {
      dispatch(setLoading(true));
      const result = await updateFieldStaff(data);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return;
      }
      refresh(result.data);
      onClose();
    } catch (e) {
      console.log(e);
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <Dialog maxWidth={windowWidth < 1919 ? 'lg' : 'xl'} fullWidth open={isOpen} onClose={null} PaperProps={{ style: { borderRadius: 15 } }}>
      <DialogTitle className='field-setting-staff-update-popup-head'>
        <div className='field-setting-staff-update-popup-head-title'>
          <IntlMessages id='field.staff.update.title' />
        </div>
        <button className='field-setting-staff-update-popup-head-close no-drag cursor-pointer' onClick={onClose}>
          <img {...icX} alt='close' />
        </button>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <div className='field-setting-staff-update-popup-body'>
          <div className='field-setting-staff-update-popup-filter'>
            <div className='field-setting-staff-update-popup-filter-item'>
              <div className='field-setting-staff-update-popup-filter-item-title'>
                <IntlMessages id='user.name' />
              </div>
              <div className='field-setting-staff-update-popup-filter-item-input'>
                <input
                  type='text'
                  placeholder={formatMessage({ id: 'field.staff.update.popup.filter.name' })}
                  value={name}
                  onChange={e => setName(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      setNowFilter({ name, phone });
                    }
                  }}
                />
                {name && <img {...icXCircle} alt='close' className='cursor-pointer no-drag' onClick={() => setName('')} />}
              </div>
            </div>
            <div className='field-setting-staff-update-popup-filter-item'>
              <div className='field-setting-staff-update-popup-filter-item-title'>
                <IntlMessages id='common.phone' />
              </div>
              <div className='field-setting-staff-update-popup-filter-item-input'>
                <input
                  type='text'
                  placeholder={formatMessage({ id: 'field.staff.update.popup.filter.phone' })}
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      setNowFilter({ name, phone });
                    }
                  }}
                />
                {phone && <img {...icXCircle} alt='close' className='cursor-pointer no-drag' onClick={() => setPhone('')} />}
              </div>
            </div>
            <button className='field-setting-staff-update-popup-filter-item-button-search cursor-pointer no-drag' onClick={() => setNowFilter({ name, phone })}>
              <IntlMessages id='button.search' />
            </button>
            <button
              className={`field-setting-staff-update-popup-filter-item-button-reset no-drag ${nowFilter ? 'cursor-pointer' : 'disabled'}`}
              onClick={() => {
                setNowFilter(null);
                setName('');
                setPhone('');
              }}
              disabled={!nowFilter}
            >
              <img {...icSync} alt='sync' />
              <IntlMessages id='widgets.reset' />
            </button>
          </div>
          <div className='field-setting-staff-update-popup-header'>
            <div className='field-setting-staff-update-popup-header-left'>
              <div className='field-setting-staff-update-popup-header-title'>
                <div className='field-setting-staff-update-popup-header-title-text'>
                  {nowFilter ? <IntlMessages id='dashboard.field.account.book.search.result' /> : <IntlMessages id='field.staff.update.popup.header.title' />}
                </div>
                <div className='field-setting-staff-update-popup-header-title-count'>{count}</div>
              </div>
            </div>
            {!user.isStaff && (
              <button className='field-setting-staff-update-popup-header-button cursor-pointer no-drag' onClick={() => window.open('/admin/setting/user/list', '_blank')}>
                <IntlMessages id='field.staff.add' />
                <div className='field-setting-staff-update-popup-header-button-arrow'>
                  <img {...icArrowRight} alt='arrow-right' />
                </div>
              </button>
            )}
          </div>
          <div style={{ overflow: 'auto', maxHeight: windowWidth < 1919 ? '456px' : '500px' }}>
            <Table stickyHeader className='field-setting-staff-update-popup-table'>
              <TableHead className='field-setting-staff-update-popup-table-head'>
                <TableRow className='field-setting-staff-update-popup-table-row'>
                  <IntlTableCell style={{ width: '80px' }} className='field-setting-staff-update-popup-table-cell' id='button.select' />
                  <TableCell style={{ width: '150px' }} className='field-setting-staff-update-popup-table-cell'>
                    <div className='field-setting-staff-update-popup-table-cell-head-sort cursor-pointer no-drag' onClick={() => setSort(prev => (prev === '-id' ? 'id' : '-id'))}>
                      <IntlMessages id='staff.no' />
                      <img {...icArrowDown} alt='arrow-down' />
                    </div>
                  </TableCell>
                  <TableCell className='field-setting-staff-update-popup-table-cell'>
                    <div className='field-setting-staff-update-popup-table-cell-head-sort cursor-pointer no-drag' onClick={() => setSort(prev => (prev === '-name' ? 'name' : '-name'))}>
                      <IntlMessages id='common.name' />
                      <img {...icArrowDown} alt='arrow-down' />
                    </div>
                  </TableCell>
                  <IntlTableCell style={{ width: '160px' }} className='field-setting-staff-update-popup-table-cell' id='common.phone' />
                  <IntlTableCell style={{ width: '210px' }} className='field-setting-staff-update-popup-table-cell' id='staff.fields.num' />
                  <TableCell style={{ width: '150px' }} className='field-setting-staff-update-popup-table-cell'>
                    <div
                      className='field-setting-staff-update-popup-table-cell-head-sort cursor-pointer no-drag'
                      onClick={() => setSort(prev => (prev === '-dateEntered' ? 'dateEntered' : '-dateEntered'))}
                    >
                      <IntlMessages id='setting.staff.date.entered' />
                      <img {...icArrowDown} alt='arrow-down' />
                    </div>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody className='field-setting-staff-update-popup-table-body'>
                {items.map(item => {
                  const isSelected = selectedStaffs.some(x => x._id === item._id);
                  return (
                    <TableRow key={item._id} className={`field-setting-staff-update-popup-table-row cursor-pointer no-drag ${!item.active && 'inactive'}`} onClick={() => toggleCheck(item)}>
                      <TableCell align='center' className='field-setting-staff-update-popup-table-cell'>
                        <div className='field-setting-staff-update-popup-table-cell-check-container'>
                          {isSelected ? (
                            <div className='field-setting-staff-update-popup-table-cell-check'>
                              <img {...icCheck} alt='check' />
                            </div>
                          ) : (
                            <div className='field-setting-staff-update-popup-table-cell-check-none' />
                          )}
                        </div>
                      </TableCell>
                      <TableCell align='center' className='field-setting-staff-update-popup-table-cell'>
                        {item.id}
                      </TableCell>
                      <TableCell align='center' className='field-setting-staff-update-popup-table-cell'>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(changeWeightSelectedWord(item.name, nowFilter?.name || '')) }} />
                      </TableCell>
                      <TableCell align='center' className='field-setting-staff-update-popup-table-cell'>
                        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(changeWeightSelectedWord(item.phone, nowFilter?.phone || '')) }} />
                      </TableCell>
                      <TableCell align='center' className='field-setting-staff-update-popup-table-cell'>
                        {item.fields}
                      </TableCell>
                      <TableCell align='center' className='field-setting-staff-update-popup-table-cell'>
                        {dateFormat(item.dateEntered, locale)}
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </div>
        </div>
        <Pagination isEmpty={false} page={page} setPage={setPage} totalPage={lastPage} />
        <div className='field-setting-staff-update-popup-button'>
          <button className='field-setting-staff-update-popup-button-close cursor-pointer no-drag' onClick={onClose}>
            <IntlMessages id='button.close' />
          </button>
          <button className='field-setting-staff-update-popup-button-save cursor-pointer no-drag' onClick={onUpdateStaff}>
            <IntlMessages id='field.staff.update.popup.button.save' values={{ count: selectedStaffs.length }} />
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default UpdatePopup;
